<button
  type="button"
  nz-button
  nzType="link"
  class="batch-email-btn"
  [disabled]="!canBatchEmail"
  nz-tooltip
  [nzTooltipTitle]="'Batch Email'"
  (click)="openSelector()"
>
  <span nz-icon nzType="mail"></span>
</button>

<app-batch-email-modal
  *ngIf="modalVisible"
  [visible]="modalVisible"
  [selectedRows]="selectedRows"
  [aclKey]="aclKey"
  [country]="country"
  (close)="closeModal()"
></app-batch-email-modal>
